import React, { useState, useEffect } from 'react';
import './App.css';
import './styles/variables.css';
import { Hero, About, Experience, Projects, Contact } from './pages';
import { Navbar, Waves } from './components';

function App() {
  const [isNavbarFixed, setIsNavbarFixed] = useState(false);

  const handleScroll = () => {
    const aboutSection = document.getElementById('about');
    const navbarHeight = document.querySelector('.navbar').offsetHeight;
    const scrollPosition = window.scrollY;

    // Calculate the position of the about section relative to the top of the viewport
    const aboutSectionOffset = aboutSection.offsetTop - navbarHeight;

    if (scrollPosition >= aboutSectionOffset) {
      setIsNavbarFixed(true);
    } else if (scrollPosition <= aboutSectionOffset + navbarHeight) {
      setIsNavbarFixed(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Get computed styles to access CSS variables
  const styles = getComputedStyle(document.documentElement);

  return (
    <div>
      <Waves
        lineColor={styles.getPropertyValue('--waves-lineColor').trim()}
        backgroundColor={styles.getPropertyValue('--waves-background').trim()}
        waveSpeedX={0.02}
        waveSpeedY={0.01}
        waveAmpX={60}
        waveAmpY={40}
        friction={0.9}
        tension={0.01}
        maxCursorMove={120}
        xGap={12}
        yGap={36}
      />
      <div id="hero">
        <Hero />
      </div>
      <Navbar isFixed={isNavbarFixed} />
      <About />
      <Experience />
      <Projects />
      <Contact />
    </div>
  );
}

export default App;
